export const INVENTORY_LIST_VARIANT = 'INVENTORY_LIST_VARIANT';
export const INVENTORY_UPDATE_QUANTITY = 'INVENTORY_UPDATE_QUANTITY';
export const INVENTORY_UPDATES_QUANTITY = 'INVENTORY_UPDATES_QUANTITY';
export const INVENTORY_RELOAD = 'INVENTORY_RELOAD';
